
import { createContext, Suspense, useContext, useMemo, useState } from "react";
import ProgressIndicatorView from "./views/common/ProgressIndicatorView";
import ErrorDialogView from "./views/common/ErrorDialogView";
import CommonAlert from "./views/common/CommonAlert";


const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
    const segments = window.location.pathname.split('/').filter(Boolean);
    const isResearchPage = segments.includes('rd');

    const [inProgress, setInProgress] = useState(isResearchPage ? false : true);
    const [error, setError] = useState(null);
    const [appAlert, setAppAlert] = useState();

    const showProgressIndicator = () => {
        setInProgress(true)
    }

    const hideProgressIndicator = () => {
        setInProgress(false)
    }

    const showError = (error) =>{
        setError(error);
    }

     const hideError = () =>{
        setError(null);
    }
    const values = { showProgressIndicator, hideProgressIndicator, showError, hideError, setAppAlert };

    const memoObj = useMemo(() => (values), [inProgress]);
    return (
        <Suspense fallback={<ProgressIndicatorView/>} open={true}>
            <AppContext.Provider value={memoObj}>
                {children}
                {inProgress && <ProgressIndicatorView open={inProgress} />}
                {error && <ErrorDialogView open={error} onClose={hideError}/>}
                {appAlert && <CommonAlert show={appAlert.show} severity={appAlert.severity || 'warning'} message={appAlert.message} onClose={() => setAppAlert(null)} />}
            </AppContext.Provider>
        </Suspense>
    );
}

export const useApp = () => {
    return useContext(AppContext);
};